import { graphql, useStaticQuery } from 'gatsby';
import { isDefined } from '@lucid/utils';

import type { Lucid } from '../types/types';

const useNavMenu = (
  id: number | undefined,
  languageKey: Lucid.I18n.LanguagesShortCode,
): Lucid.Directus.Generated.Nav_Section_Translations[] | undefined => {
  const { directus } = useStaticQuery(graphql`
    query useNavMenuQuery {
      directus {
        main_nav {
          id
          sections(sort: ["order", "id"]) {
            nav_section_id {
              translations {
                id
                languages_code {
                  short_code
                }
                is_dropdown
                link {
                  default_link_text
                  final_url
                  beacon_id
                }
                dropdown_text
                dropdown_title
                dropdown_sections(sort: ["order", "id"]) {
                  order
                  dropdown_section_id {
                    id
                    label
                    link_set(sort: ["order", "id"]) {
                      dropdown_link_id {
                        id
                        link {
                          default_link_text
                          final_url
                          beacon_id
                        }
                        text
                        image {
                          filename_disk
                          uploaded_on
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  if (!id) return undefined;

  const allMenus = directus.main_nav as Lucid.Directus.Generated.Main_Nav[];
  const selectedMenuSections = (allMenus.find(menu => menu.id === `${id}`)?.sections || [])
    .map(section => section.nav_section_id)
    .filter(isDefined);

  const translatedSections = selectedMenuSections?.reduce<Lucid.Directus.Generated.Nav_Section_Translations[]>(
    (result, current) => {
      const trSection = current?.translations?.find(tr => tr.languages_code?.short_code === languageKey);
      if (trSection) return [...result, trSection];

      return result;
    },
    [],
  );

  return translatedSections;
};

export default useNavMenu;
